import React, { useState } from 'react';
import { useSnackbar } from 'material-ui-snackbar-provider';
import { Tooltip } from '@material-ui/core';

import Modal from '../../Modal';
import { VIDEOFEED } from '../../../../enums';
import styles from './DownloadSelectedVideosModal.module.scss';
import { ContainedButton, OutlinedButton } from '../../Buttons';
import { downloadJSONData, downloadVideoData } from '../../../../api';

type TDownloadSelectedVideosProps = {
  isOpen: boolean;
  switchModal: () => void;
  feed: VIDEOFEED;
};

const DownloadSelectedVideosModal: React.FC<TDownloadSelectedVideosProps> = ({ isOpen, switchModal, feed }) => {
  const [loading, setLoading] = useState(false);
  const [selectedVideos, setSelectedVideos] = useState<number[]>([]);
  const notification = useSnackbar();

  const onClose = () => {
    switchModal();
    setLoading(false);
  };

  const onSelect = (id: number) => {
    if (selectedVideos.includes(id)) {
      setSelectedVideos((prev) => prev.filter((video) => video !== id));
    } else {
      setSelectedVideos([...selectedVideos, id]);
    }
  };

  const handleVideoDownload = async () => {
    try {
      setLoading(true);

      await Promise.all(
        selectedVideos.map(async (videoId, idx) => {
          const responseUrl = await downloadVideoData(`${videoId}`, true);
          const downloadUrl = responseUrl?.data?.url;
          const link = document.createElement('a');

          link.href = downloadUrl;
          document.body.appendChild(link);

          setTimeout(() => {
            link.click();
            document.body.removeChild(link);
          }, 5000 * idx);
        }),
      );
    } catch (err: any) {
      console.error(err);
      if (err?.response?.data?.message) {
        notification.showMessage(err?.response?.data?.message);
      }
    } finally {
      setLoading(false);
      onClose();
    }
  };

  return (
    <Modal open={isOpen} onClose={!loading ? onClose : () => {}} loading={loading}>
      <div className={styles.modalBody}>
        <div className={styles.modalTitle}>
          <div className={styles.modalTop}>
            <div className={styles.titleText}>Choose angels that you want to download</div>
          </div>
        </div>
        <div className={styles.form}>
          <div className={styles.actionBtns}>
            <div className={styles.videoOptionWrappers}>
              {feed.videos.map(({ id, name }) => (
                <Tooltip placement="top" key={id} arrow title={<div className={styles.tooltip}>{name}</div>}>
                  <div className={styles.videoOptionWrapper} onClick={() => onSelect(+id)}>
                    <div className={styles.elementLeftSide}>{name}</div>
                    <div className={styles.checkboxWrapper30}>
                      <span className={styles.checkbox}>
                        <input type="checkbox" checked={selectedVideos.includes(+id)} />
                        <svg>
                          <use xlinkHref="#checkbox-30" className={styles.checkbox}></use>
                        </svg>
                      </span>
                      <svg xmlns="http://www.w3.org/2000/svg" style={{ display: 'none' }}>
                        <symbol id="checkbox-30" viewBox="0 0 22 22">
                          <path
                            fill="none"
                            stroke="currentColor"
                            d="M5.5,11.3L9,14.8L20.2,3.3l0,0c-0.5-1-1.5-1.8-2.7-1.8h-13c-1.7,0-3,1.3-3,3v13c0,1.7,1.3,3,3,3h13 c1.7,0,3-1.3,3-3v-13c0-0.4-0.1-0.8-0.3-1.2"
                          />
                        </symbol>
                      </svg>
                    </div>
                  </div>
                </Tooltip>
              ))}
            </div>

            <ContainedButton className={styles.containedButton} disabled={loading || !selectedVideos.length} onClick={handleVideoDownload}>
              <span>Download</span>
            </ContainedButton>

            {/* <ContainedButton className={styles.containedButton} disabled={loading} onClick={handleAnglesDownload}>
              <span>Angles package</span>
            </ContainedButton> */}

            <OutlinedButton className={styles.outlinedButton} disabled={loading} kind="default" onClick={onClose}>
              <span>Cancel</span>
            </OutlinedButton>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default DownloadSelectedVideosModal;
